import { Bell } from '@ondit/ui/icons'
import { AgentBlock } from '@/blocks/blocks/agent'
import type { BlockConfig } from '@/blocks/types'

export const OnditNotifyBlock: BlockConfig = {
  type: 'ondit_notify',
  name: 'Notification',
  description: 'Notify people in this account in Ondit, and by email if they chose to be',
  longDescription:
    'Delivered to the bell of each recipient. Whether it is also emailed, and how often, is each recipient’s own choice in Settings → Notifications.',
  category: 'blocks',
  bgColor: AgentBlock.bgColor,
  icon: Bell,
  subBlocks: [
    {
      id: 'recipients',
      title: 'Recipients',
      type: 'dropdown',
      options: [
        { id: 'me', label: 'Whoever runs the workflow' },
        { id: 'editors', label: 'Everyone who can edit this brand' },
        { id: 'admins', label: 'Account owners and admins' },
      ],
      value: () => 'me',
    },
    {
      id: 'title',
      title: 'Title',
      type: 'short-input',
      placeholder: 'What happened',
      required: true,
    },
    {
      id: 'body',
      title: 'Message',
      type: 'long-input',
      placeholder: 'Details, with references to earlier blocks',
    },
  ],
  tools: { access: [] },
  inputs: {
    recipients: { type: 'string', description: 'me, editors or admins' },
    title: { type: 'string', description: 'Notification title' },
    body: { type: 'string', description: 'Notification message' },
  },
  outputs: {
    recipients: { type: 'number', description: 'People the notification was addressed to' },
    sent: { type: 'number', description: 'Notifications delivered by this run' },
  },
}
